export default {
  title: 'Financial',

  rule: 'Rules',
  tax: 'Vat',
  paymentInfo: 'Payment info',
  NegativeValue: 'Bank and fund can be negative',

  labels: {
    activeMaxDebt: 'Enable max debt',
    defaultBank: 'Default bank',
    defaultCash: 'Default cash',
    defaultPaymentGateway: 'Default paymentGateway',
    purchaseTax: 'Purchase vat percent',
    saleTax: 'Sale vat percent',
    vat: 'Vat tax percent',
    taxRegistrationNumber: 'Tax Registration Number',
    bankName: 'Bank name',
    accountName: 'Account name',
    accountNumber: 'Account number',
    iban: 'IBAN',
    swiftCode: 'Swift code',
    cardNumber: 'Card number'
  },

  notifications: {
    negativeBalanceError: 'Due to the negative balance of a number of banks or funds, the desired settings has error',
    wrongValues: 'The entered information is not valid',

    edit: {
      success: 'Financial information has been updated successfully',
      error: 'Update financial information has error'
    }
  }
}
